module.exports = "<div class=\"outer-container\">\n    <router-outlet></router-outlet>\n</div>"